export const BillingLedgerEntryStatus = {
  COMMITTED: "COMMITTED",
  TEMPORARY: "TEMPORARY",
};

export const PriceComponentsName = {
  GST: "GST",
  Subtotal: "Subtotal",
};
